import { useEffect, useState } from "react"

import { useAuthorizationDataContext } from '../../../Helpers/AuthorizationDataProvider';
import { useIntlWrapperContext } from "../../../Helpers/IntlWrapperProvider";
import useFetchWrapper, { HttpResponse } from "../../../Helpers/useFetchWrapper";

import { TabStatus } from "../ApplicationsTab/ApplicationsTab.model";
import { Admin, Props } from "./AdminsTab.model";

export const pageSize = 12;

export const useAdminsTab = ({filters}: Props) => {
	const [ adminToDelete, setAdminToDelete ] = useState<Admin | null>(null);
	const [ admins, setAdmins ] = useState<any>();
	const [ adminsPagination, setAdminsPagination ] = useState({ page: 1, size: pageSize, total: 0 });
	const [ tabStatus, setTabStatus ] = useState<TabStatus>(TabStatus.Loading);

	const { getI18nCountryName } = useIntlWrapperContext();
	const { get, post, put } = useFetchWrapper();
	const { isAuthorized } = useAuthorizationDataContext();

	useEffect(() => {
		getAdmins();
	}, [adminsPagination.page]);

	useEffect(() => {
		if (adminsPagination.page > 1) {
			setAdminsPagination({ ...adminsPagination, page: 1, })
		} else {
			getAdmins();
		}

	}, [ filters ]);

	const deleteUser = async (id: string) => {
		await put(`/user/delete/${id}`, {});

		getAdmins();
	}

	const getAdmins = async () => {

		setTabStatus(TabStatus.Loading);

		const response: HttpResponse<any> = await get(`/user/admin?page=${adminsPagination.page}&size=${adminsPagination.size}&${filters}`);
	
		if (response.parsedBody) {
			const { users, count } = response.parsedBody;
			setAdmins(users);
			setAdminsPagination({ ...adminsPagination, total: count });
			setTabStatus(TabStatus.Loaded);
		}
		else {
			setTabStatus(TabStatus.Error);
		}
	}

	const onChangeAdminsPagination = (page: number) => {
		setAdminsPagination({ ...adminsPagination, page});
	}
	
	const reinviteAdmin = async(id: string) => {
		await post(`/user/reinvite/${id}`, {});
	}

	return {
		deleteUser,
		getAdmins,
		getI18nCountryName,
		isAuthorized,
		onChangeAdminsPagination,
		reinviteAdmin,
		setAdminToDelete,
		state: {
			adminToDelete,
			admins,
			adminsPagination,
			tabStatus,
		},
	}
}